import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Logs } from '../app.urls';

@Injectable({
  providedIn: 'root'
})
export class WebErrorService {

  private config: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  }

  constructor(private snackBar: MatSnackBar, private http: HttpClient) { }

  public handleAPIErrors(error: HttpErrorResponse, customMessage: string = "", showSnackBar: boolean = false, messageType: 'warn' | 'alert' = 'warn') {
    switch (error.status) {
      case 400:
        console.log(`400 Bad Request: ${customMessage ? customMessage : error.message}`);
        break;
      case 404:
        console.log(`404 Not Found: ${customMessage ? customMessage : error.message}`);
        break;
      case 408:
        console.log(`408 Request Timeout: ${customMessage ? customMessage : error.message}`);
        break;
      case 500:
        console.log(`500 Internal Server: ${customMessage ? customMessage : error.message}`);
        break;
      case 502:
        console.log(`502 Bad Gateway: ${customMessage ? customMessage : error.message}`);
        break;
      case 504:
        console.log(`504 Gateway Timeout: ${customMessage ? customMessage : error.message}`);
        break;
      case 505:
        console.log(`505 HTTP Version Not Supported: ${customMessage ? customMessage : error.message}`);
        break;
      case 507:
        console.log(`507 Insufficient Storage: ${customMessage ? customMessage : error.message}`);
        break;
      case 508:
        console.log(`508 Loop Detected: ${customMessage ? customMessage : error.message}`);
        break;
      default:
        console.log(`${error.status} Error : ${customMessage ? customMessage : error.error.message}`);
        customMessage = error.error.message;
        break;
    }

    if (showSnackBar) {
      this.showError(customMessage ? customMessage : error.error.message, messageType);
    }

    // Add log
    this.logErrors(error, customMessage ? customMessage : error.message);
  }

  public customErrors(customMessage: string, showSnackBar: boolean = false, messageType: 'warn' | 'alert' = 'warn') {
    if (showSnackBar) {
      this.showError(customMessage, messageType);
    } else {
      console.log(customMessage);
    }
  }

  private showError(message: string, type: 'warn' | 'alert') {
    this.config['panelClass'] = ['notification', type];
    this.snackBar.open(message, '', this.config);
  }

  logErrors(error: HttpErrorResponse, errorMessage: string): void {
    const domain = window.location.hostname;
    const errorLog: any = {
      logLevel:"Error",
      message: errorMessage,
      domain: domain,
      subdomain: this.getSubdomain(),
      stacktrace: JSON.stringify(error),
      code: `${error.status}`
    };

    this.http.post<any>(Logs.logError, errorLog, { 'headers': { 'content-type': 'application/json' } }).subscribe((data) => {
      if (!data) {
        console.log('Failed to log.');
      }
    }, (error: any) => {
      console.log('Failed to log.');
    });

  }

  getSubdomain(): string {
    const domain = window.location.hostname;
    let subdomain: string = '';
    if (
      domain.indexOf('.') < 0 ||
      domain.split('.')[0] === 'example' ||
      domain.split('.')[0] === 'lvh' ||
      domain.split('.')[0] === 'www'
    ) {
      subdomain = 'devstg';
    } else {
      subdomain = domain.split('.')[0];
    }
    return subdomain;
  }
}
